import Die from "./Die";
import "./DiceBox.css";
import { useAppSelector } from "./store";

function DiceBox() {
  const game = useAppSelector((state) => {
    return state.game;
  });

  const dice = game.dice;

  let diceJsx: JSX.Element;

  if (dice) {
    diceJsx = (
      <div className="diceRow">
        {game.redLocked ? "" : <Die key="red" color="red" number={dice.red} />}
        {game.yellowLocked ? (
          ""
        ) : (
          <Die key="yellow" color="yellow" number={dice.yellow} />
        )}
        {game.blueLocked ? (
          ""
        ) : (
          <Die key="blue" color="blue" number={dice.blue} />
        )}
        {game.greenLocked ? (
          ""
        ) : (
          <Die key="green" color="green" number={dice.green} />
        )}
        <Die key="white1" color="white" number={dice.white[0]} />
        <Die key="white2" color="white" number={dice.white[1]} />
      </div>
    );
  } else {
    diceJsx = <span />;
  }

  return <div className="diceBox centerContainer">{diceJsx}</div>;
}

export default DiceBox;
